import { render, staticRenderFns } from "./PendingCollectionPage.vue?vue&type=template&id=4dd11262&scoped=true&"
import script from "./PendingCollectionPage.vue?vue&type=script&lang=js&"
export * from "./PendingCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./PendingCollectionPage.vue?vue&type=style&index=0&id=4dd11262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd11262",
  null
  
)

export default component.exports